import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getFormValues } from "redux-form";

import { Mixpanel } from "../../../../actions/mixpanel.actions";
import * as projectActions from "../../../../actions/project.actions";
import * as skillsActions from "../../../../actions/skills.actions";

import ProjectSkills from "../components/ProjectSkills";

const steps = projectId => [
  {
    caption: "Basics",
    url: `/company/project/id/${projectId}/basics`
  },
  {
    caption: "Details",
    url: `/company/project/id/${projectId}/details`
  },
  {
    caption: "Skills",
    url: `/company/project/id/${projectId}/skills`
  },
  {
    caption: "Budget",
    url: `/company/project/id/${projectId}/budget`
  },
  {
    caption: "Review",
    url: `/company/project/id/${projectId}/review`
  }
];

class ProjectSkillsContainer extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.projectActions.getProject(this.props.match.params.projectId);
    this.props.skillsActions.fetchSkills();
  }

  handleSubmit(data) {
    const adminEdit = false;
    const loading = true;

    // Track Mixpanel event
    Mixpanel.track("Project Creation - Skills - Save + Continue");

    this.props.projectActions.updateProject(
      data,
      "budget",
      this.props.match.params.projectId,
      adminEdit,
      loading
    );
  }

  render() {
    return this.props.project ? (
      <ProjectSkills
        formValues={this.props.formValues || {}}
        project={this.props.project}
        skills={this.props.skills}
        steps={steps(this.props.match.params.projectId)}
        onSubmit={this.handleSubmit}
      />
    ) : null;
  }
}

const mapStateToProps = state => {
  return {
    formValues: getFormValues("projectSkills")(state),
    project: state.project.data.data,
    skills: state.skills.skills.data
  };
};

const mapDispatchToProps = dispatch => ({
  projectActions: bindActionCreators(projectActions, dispatch),
  skillsActions: bindActionCreators(skillsActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectSkillsContainer);



// WEBPACK FOOTER //
// ./src/routes/employer/project/containers/ProjectSkillsContainer.js